import React from "react";
import { MailCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

export function VerificationPending({ email, resending, onResend, onBack }) {
  const { t } = useTranslation();
  return (
    <div className="text-center py-6" data-testid="verification-pending">
      <div className="h-16 w-16 rounded-full bg-[#2D6A4F]/10 flex items-center justify-center mx-auto mb-4">
        <MailCheck className="h-8 w-8 text-[#2D6A4F]" />
      </div>
      <h2 className="font-display text-xl font-extrabold mb-2">{t("authx.verifyTitle")}</h2>
      <p className="text-sm text-[#5C574F] mb-1">{t("authx.sentTo")}</p>
      <p className="text-sm font-bold text-[#1A1A1A] mb-4 break-all" data-testid="pending-email">{email}</p>
      <p className="text-sm text-[#5C574F] mb-6">{t("authx.instructions")}</p>
      <button
        data-testid="resend-verification-btn"
        onClick={onResend}
        disabled={resending}
        className="w-full h-14 rounded-2xl bg-[#E85D04] text-white font-bold active:scale-95 transition-transform disabled:opacity-60 mb-3"
      >
        {resending ? t("common.sending") : t("authx.resendBtn")}
      </button>
      <button
        data-testid="back-to-login-btn"
        onClick={onBack}
        className="w-full h-12 rounded-2xl border border-[#E5E0D8] text-[#5C574F] font-semibold"
      >
        {t("authx.backToLogin")}
      </button>
    </div>
  );
}
